import RevolverBigWins from "slotworks/integration/revolver/states/revolver-big-wins";
import gameState from "slotworks/model/game-state";
import ICFreespinRecord from "integration/revolver/schema/freespin-record";
import BonusRecord from "integration/revolver/schema/bonus-record";
import soundManager from "slotworks/sound/sound-manager";
import RevolverSettings from "model/revolver-settings";
import { StartBaseMusic } from "commands/music";

export default class ICBigWins extends RevolverBigWins {

    public onEnter(cascadeSkip: boolean) {   
        if(this.isFreespinsOrJackpot()) {
            this.complete();
        } else {
            super.onEnter(cascadeSkip);
        }
    }

    public onExit() {
        super.onExit();

        if(!this.isFreespinsOrJackpot()) {
            StartBaseMusic();
        }
    }

    private isFreespinsOrJackpot() {
        const record = gameState.getCurrentGame().getCurrentRecord();    
        if(record instanceof ICFreespinRecord) {            
            return true;    
        }
        const bonusRecord = record as BonusRecord;
        return bonusRecord.inFreespins || bonusRecord.retriggers > 0 || (record as any).isJackpotWon;
    }
    
}